// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "d26b55057f90763598f3aad3b2f89e6f" + ".js";
};